import companyService from '@services/companyService';

export default {
  data() {
    return {
      companies: [],
    };
  },
  mounted() {
    companyService.companiesStorage().then((data) => (this.companies = data));
  },
  computed: {
    loadingCompanies() {
      return this.companies === undefined || this.companies.length === 0;
    },
    findCompanyPremium() {
      return this.companies.filter((c) => c.name.includes('PREMIUM'))[0];
    },
    findCompanyConfort() {
      return this.companies.filter((c) => c.name.includes('CONFORT'))[0];
    },
    findCompanyEssentielle() {
      return this.companies.filter((c) => c.name.includes('ESSENTIELLE'))[0];
    },
  },
  methods: {
    displayForCompany(id, returnLabel = '') {
      let result = this.companies.find((company) => company.id === id);
      return result ? result.name : returnLabel;
    },
  },
};
